/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const editProfileConfig = {
  FIELDS: [
    {
      type: 'text',
      compProps: {
        id: 'name',
        label: 'Organization Name',
        required: true,
        placeholder: 'Enter your Organization Name',
        errorText: 'Organization Name is required',
      },
    },
    {
      type: 'text',
      compProps: {
        id: 'description',
        label: 'Description',
        required: true,
        placeholder: 'Enter your Description',
        errorText: 'Description is required',
      },
    },
    {
      type: 'choosePhoto',
      compProps: {
        id: 'logo',
        label: 'Logo',
        required: true,
        errorText: 'Please choose Logo',
      },
    },

    {
      type: 'phoneNumber',
      compProps: {
        id: 'telephone',
        label: 'Mobile Number',
        required: true,
        placeholder: 'Enter mobile Number',
        errorText: 'Mobile number is required',
      },
    },
    {
      type: 'text',
      compProps: {
        id: 'address',
        label: 'Address',
        required: true,
        placeholder: 'Enter your address',
        errorText: 'address is required',
      },
    },
    {
      type: 'text',
      compProps: {
        id: 'city',
        label: 'City',
        required: true,
        placeholder: 'Enter your City',
        errorText: 'City is required',
      },
    },
    {
      type: 'countrySelect',
      compProps: {
        id: 'country',
        label: 'Country',
        required: true,
        errorText: 'Country is required',
        onlyCountries: ['gd', 'dm', 'in'],
        placeholder: 'Select your Country',
      },
    },
    {
      type: 'text',
      compProps: {
        id: 'website',
        label: 'Website',
        required: true,
        placeholder: 'Enter your website',
        errorText: 'website is required',
      },
    },
  ],
  layout: [
    ['name'],
    ['description'],
    ['logo'],
    ['telephone'],
    ['address'],
    ['city'],
    ['country'],
    ['website'],
  ],
};
